import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from 'src/app/services/admin.service';
import { DataService } from 'src/app/services/data.service';
import { SiteService } from 'src/app/services/site.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
	public username: string;
	public password: string;
	public twoFactorCode: string;
	public showTwoFactorStep: boolean = false;
	public userID: string;

	private returnUrl: string

	constructor(private dataService: DataService, private route: ActivatedRoute, private router: Router, private adminService: AdminService, private siteService: SiteService) {}

	ngOnInit(): void {
		this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/admin';
	}

	login() {
		this.dataService.login(this.username, this.password).subscribe(userID => {
			this.userID = userID;
			this.showTwoFactorStep = true;
		}, (err) => {
			if(err.status === 423) {
				// Display the message returned from the API for 423 status
				this.siteService.setMessage(err.error || "Account is temporarily locked.", "error");
			} else if(err.status !== 500) {
				this.siteService.setMessage("The username/password combination was not correct.", "error")
			}
		})
	}

	verify2FA() {
		if (!this.twoFactorCode) {
			this.siteService.setMessage("Please enter the authentication code.", "error");
			return;
		}

		this.dataService.verify2FA(this.userID, this.twoFactorCode).subscribe(token => {
			this.adminService.token = token;
			if(this.adminService.isSuperAdmin) {
				this.router.navigateByUrl(this.returnUrl);
			} else {
				this.router.navigate(['admin', 'employer', this.adminService.employerId, 'census-data']);
			}
		}, (err) => {
			if(err.status !== 500) {
				this.siteService.setMessage("The authentication code was not correct. Please try again.", "error")
			}
		})
	}

	goBack() {
		this.showTwoFactorStep = false;
		this.twoFactorCode = '';
		this.userID = '';
	}
}
